export const entryRemovalVisitor = (medicalLicenceNumberExists: boolean) => <ACCEPT>(view: {
   visitDoctor: () => ACCEPT;
   visitSpecialist: () => ACCEPT;
}) => (medicalLicenceNumberExists ? view.visitDoctor() : view.visitSpecialist());
